import { FiAlertTriangle, FiX } from 'react-icons/fi';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  itemName?: string;
  confirmText?: string;
  warningText?: string;
}

export default function DeleteConfirmationWidget({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  itemName,
  confirmText = 'Удалить',
  warningText = 'Это действие нельзя отменить!',
}: Props) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 dark:bg-black/70 flex items-center justify-center z-[80]">
      <div className="bg-white dark:bg-gray-900 rounded-xl shadow-2xl max-w-md w-full mx-4 border border-transparent dark:border-gray-700/60">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700/60">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-red-100 dark:bg-red-950/40 rounded-full flex items-center justify-center">
              <FiAlertTriangle className="w-5 h-5 text-red-600 dark:text-red-300" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg dark:hover:bg-white/5 dark:hover:text-gray-200"
          >
            <FiX className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6">
          <p className="text-gray-600 dark:text-gray-300 mb-4">{message}</p>
          {itemName && (
            <div className="bg-gray-50 dark:bg-gray-800/60 rounded-lg p-3 mb-4 border dark:border-gray-700/50">
              <p className="text-sm text-gray-500 dark:text-gray-400">Удаляемый элемент:</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">{itemName}</p>
            </div>
          )}
          {warningText && <p className="text-sm font-medium text-red-600 dark:text-red-300">{warningText}</p>}
        </div>
        <div className="flex justify-end space-x-3 p-6 border-t border-gray-200 dark:border-gray-700/60 bg-gray-50 dark:bg-gray-800/60 rounded-b-xl">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-200 rounded-lg dark:text-gray-200 dark:hover:bg-white/5"
          >
            Отмена
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
